module.exports = __webpack_public_path__ + "img/06.e79a9fc7.png";